import { Fragment } from 'react';
import { Link } from 'react-router';
import { EmptyState } from '../../shared/ui/components';
import { useBadges } from '../../shared/badges';
import { useMe } from '../session/SessionProvider';
import { badgeFor, describeItems, HINTS, HUB_GROUPS, HUBS, hubItems, Icon, useNavGroups, type NavItem } from './nav';

/** Página de una sección del menú: sus opciones como tarjetas grandes con una línea de ayuda. */
export function HubPage({ title }: { title: string }) {
  const hub = HUBS.find((h) => h.title === title)!;
  const items = hubItems(useNavGroups(), title);
  const badges = useBadges(useMe());
  // Algunas secciones van en grupos con título (p. ej. Administración: Dinero y Configurar).
  const defined = HUB_GROUPS[title];
  const groups: { title: string | null; items: NavItem[] }[] = defined
    ? [
        ...defined.map((g) => ({ title: g.title, items: g.routes.map((r) => items.find((i) => i.to === r)).filter((i): i is NavItem => !!i) })),
        { title: null, items: items.filter((i) => !defined.some((g) => g.routes.includes(i.to))) },
      ].filter((g) => g.items.length > 0)
    : [{ title: null, items }];
  const grouped = groups.length > 1;
  return (
    <div className="page">
      <header className="page__header">
        <h1>{hub.title}</h1>
        <p className="muted">{describeItems(items) || hub.subtitle}</p>
      </header>
      {items.length === 0 ? <EmptyState title="No tienes opciones en esta sección." /> : null}
      {groups.map((g, n) => {
        const list = (
          <ul className="hub">
            {g.items.map((item) => (
              <li key={item.to}>
                <Link to={item.to} className="hub__item">
                  <span className="hub__icon">
                    <Icon name={item.icon} />
                    {badgeFor(item, badges) > 0 ? <span className="nav-badge nav-badge--dot" aria-label={`${badgeFor(item, badges)} pendientes`}>{badgeFor(item, badges)}</span> : null}
                  </span>
                  <span>
                    <strong>{item.label}</strong>
                    {HINTS[item.to] ? <span className="small muted">{HINTS[item.to]}</span> : null}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        );
        return grouped ? (
          <section key={g.title ?? n} className="stack">
            {g.title ? <h2>{g.title}</h2> : null}
            {list}
          </section>
        ) : (
          <Fragment key={n}>{list}</Fragment>
        );
      })}
    </div>
  );
}
